// Helper functions extracted to reduce Cognitive Complexity

export const buildMeetingRequest = (data, type, scheduleData, scheduleUser) => {
  const request = {
    subject: data.subject,
    description: data.description,
    meeting_start_time: data.meeting_start_time || "",
    meeting_end_time: data.meeting_end_time,
    meeting_timezone: data.meeting_timezone,
    meeting_date: data.meeting_date || "",
  };

  if (type === "edit") {
    request.id = scheduleData?.id;
    request.relation_id = scheduleData?.relation_id;
  } else {
    request.relation_id = scheduleUser?.id;
  }

  return request;
};

export const getRedirectPath = (type, updatePage, userInfo, scheduleUser) => {
  if (type === "edit") {
    return updatePage === "calendar"
      ? "/schedule-meeting-calendar"
      : "/schedule-meeting";
  }

  return userInfo?.id === scheduleUser?.mentor_id
    ? "/current-mentees"
    : "/my-mentors";
};

export const getSubmitButtonText = (type, apiLoader) => {
  if (apiLoader) return "Loading...";
  return type === "edit" ? "Update" : "Submit";
};

export const getFormClassName = (hasError) => {
  return hasError ? "form-control is-invalid" : "form-control";
};

export const getDefaultMeetingDate = (type, scheduleData, moment) => {
  return type === "edit" ? scheduleData?.meeting_date : moment().format("YYYY-MM-DD");
};


export const getDefaultMeetingDate2 = (type, scheduleData, moment) => {
  if (type === "edit" && scheduleData?.meeting_date) {
    return moment(scheduleData.meeting_date, "DD MMMM YYYY").format("YYYY-MM-DD");
  }
  return moment().format("YYYY-MM-DD");
};


export const getDefaultStartTime = (type, scheduleData, moment) => {
  return type === "edit"
    ? moment(scheduleData?.meeting_start_datetime_converted).format("HH:mm")
    : moment().format("HH:mm");
};

export const getUserDisplayData = (type, scheduleData, scheduleUser, userInfo) => {
  if (type === "edit") {
    const isCreator = userInfo?.id === scheduleData?.creator_id;
    return {
      label: isCreator ? scheduleData?.receiver_mentor_role_id : scheduleData?.creator_mentor_role_id,
      image: isCreator ? scheduleData?.receiver_image_path : scheduleData?.creator_image_path,
      name: isCreator ? scheduleData?.receiver_name : scheduleData?.creator_name,
    };
  }

  const isMentor = userInfo?.id === scheduleUser?.mentor_id;
  return {
    label: isMentor ? "Mentee" : "Mentor",
    image: scheduleUser?.reg_fields?.image,
    name: isMentor ? scheduleUser?.mentee_name : scheduleUser?.mentor_name,
  };
};
